<template>
  <div>
    <template v-for="(phone, index) in phonelist">
      <a :href="`tel:${phone.link}`" :key="index">{{ phone.tel }}</a>
      <span :key="'split_' + index" v-if="index != phonelist.length - 1"> , </span>
    </template>
  </div>
</template>

<script>
export default {
  props: ["value"],
  computed: {
    phonelist() {
      var phonelist = this.value ? this.value.trim() : "";
      if (phonelist == null || phonelist == "") return [];

      phonelist = phonelist.split(",");
      return phonelist.map((el) => {
        if (el.match(/^[0-9-]+/))
          return {
            link: el.replace("0", "+66"),
            tel: el,
          };
        else return { link: el, tel: el };
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
